import ASStoreProduct from "../../component/store/store product/AS_Store_Product";
import { useParams } from "react-router-dom";

const AsStorePpducts = () => {
  const { id } = useParams();

  return (
    <div className="STORE">
      <ASStoreProduct ID={id} />
    </div>
  );
};

export default AsStorePpducts;
